import { render } from "./PreApp.vue?vue&type=template&id=6a11d8de"
import script from "./PreApp.vue?vue&type=script&lang=ts"
export * from "./PreApp.vue?vue&type=script&lang=ts"

import "./PreApp.vue?vue&type=style&index=0&id=6a11d8de&lang=css"
script.render = render

export default script